<template>
  <Pagination
    v-if="typeof loadMore == 'undefined' && !loading"
    v-model="currentPage"
    :records="totalRecords"
    :per-page="limit"
    class="m-2"
  ></Pagination>
  <div  class="row d-flex justify-content-center" v-if="loading">
    <div class="spinner-border text-primary"></div>
  </div>
  <div
    class="row w-100 my-lg-3 justify-content-center"
    v-if="pagination.total > 0 && pagination.perPage < pagination.total"
  >
    <Button
      class="btn btn-primary"
      :loading="loading"
      v-if="(currentPage*limit < totalRecords) && (typeof loadMore != 'undefined' && !hideLoadMore)"
      @click="loadMoreRecords"
    >
      Load More
    </Button>
  </div>
<!--  <SkeletonLoader-->
<!--    v-if="loading"-->
<!--    :loading="loading"-->
<!--    :headerLength="headerLength"-->
<!--  ></SkeletonLoader>-->

  <!--<OverlayLogo v-if="loading && typeof(loadMore) == 'undefined'" ></OverlayLogo>-->

  <!--<OverlayLogo v-if="loading" ></OverlayLogo>-->
</template>


<script>
export default {
  emits: ["getRecords"],
  props: [
    "url",
    "search",
    "infiniteLoad",
    "force",
    "formData",
    "submit",
    "submitUrl",
    "hideLoader",
    "updateForm",
    "hidePagination",
    "hideLimit",
    "defaultLimit",
    "defaultLimitClass",
    "defaultLimitText",
    "bodyData",
    "loadMore",
    "headerLength",
    "responseDataKey"
  ],
  data() {
    return {
      dataUrl: "",
      records: [],
      pagination: "",
      loading: true,
      noRecordFound: false,
      callInProgress: false,
      limit: this.defaultLimit ? this.defaultLimit : 10,
      currentPage: 1,
      hideLoadMore: false
    };
  },
  mounted() {
    this.dataUrl = this.url;
    setTimeout(() => {
      if (!this.infiniteLoad) {
        this.getList(false);
      }
    }, 1000);
  },
  methods: {
    loadMoreRecords() {
      let total = this.pagination.total;
      let perPage = this.pagination.perPage;
      let totalPages = parseInt(total / perPage) + 1;
      if (this.currentPage == totalPages) {
        this.hideLoadMore = true;
      } else {
        this.currentPage += 1;
      }
    },
    getList(page) {
      var url = this.dataUrl;
      var data = {
        page: 1,
        perPage: this.limit
      };
      if (this.bodyData) {
        data = Object.assign(data, this.bodyData);
        this.loading = false;
      }
      if (typeof url == "undefined" || url == "") {
        return false;
      }
      if (!this.hideLoader) {
        this.loading = true;
      }
      if (typeof page !== "undefined" && page) {
        data.page = page;
      }
      if (this.callInProgress) {
        return false;
      }
      this.callInProgress = true;
      this.$emit("loading", this.loading);
      this.$emit("skeletonLoading", this.loading);
      this.makeRequest("post", url, data, {}, false).then(callResponse => {
        this.callInProgress = false;
        this.loading = false;
        this.$emit("loading", this.loading);
        this.$emit("skeletonLoading", this.loading);
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            var response = callResponse.response.data.data;
            if(typeof (this.responseDataKey) != 'undefined'){
              response = response[this.responseDataKey];
            }
            var result = {
              data: response.data,
              noRecordFound: false,
              pagination: response.paginationData
            };
            this.currentPage = response.paginationData.currentPage;
            this.$emit("getRecords", result);
            this.pagination = response.paginationData;
          }
          // else if (code == 401) {
          // }
        }
      });
    }
  },
  watch: {
    url(val) {
      this.dataUrl = val;
      this.getList();
    },
    force(value) {
      if (value) {
        this.getList();
      }
    },
    defaultLimit(val) {
      this.limit = val;
      this.getList();
    },
    currentPage(page) {
      this.getList(page);
    },
    bodyData() {
      this.getList();
    }
  },
  computed: {
    totalRecords() {
      return this.pagination ? this.pagination.total : 0;
    }
  }
};
</script>
<style>
p.VuePagination__count.VuePagination__count {
  display: none !important;
}
.VuePagination {
  /*float: right;*/
  margin: 1.5rem !important;
}
</style>
